import {Outlet} from 'external/react'
import {styled, Box} from 'external/material'
import InfoBar from 'components/InfoBar'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'

const StyledGradebook = styled(Box)(groupGradeStyles)

export default function GradebookContainer() {
  const {navigation} = useSession()
  const {translate} = useTranslations()
  const title = translate('grade-section-title')
  return (
    <StyledGradebook className="root">
      <InfoBar {...{to: false, title, navigation}} />
      <Box className="content">
        <Box id="groupGradesContainer" className="groupGradesContainer">
          <Outlet />
        </Box>
      </Box>
  </StyledGradebook>
  )
}

function groupGradeStyles() {
  return {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'hidden',
    "& .infoBar": {
      padding: "20px 0"
    },
    "& .headerLabel.name": {
      marginLeft: 35 
    },
    "& > .content": {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
      paddingBottom: 20,
      "& > .groupGradesContainer": {
        display: 'flex',
        flexGrow: 1,
        overflowY: 'auto'
      },
    },
  }
}
